export default __webpack_public_path__ + "static/media/do-warmup.4398b3d4.svg";